import { IDetalheFeriasProventosDescontos } from '@core/models';
import { formatCurrency } from '@core/utils';
import { Grid, Skeleton, Typography } from '@mui/material';
import * as React from 'react';

interface IProventosDescontosFeriasProps {
    data: IDetalheFeriasProventosDescontos;
    showValues?: boolean;
}
export const ProventosDescontosFerias: React.FC<IProventosDescontosFeriasProps> = ({ data, showValues = false }) => {
    return (
        <Grid sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '13px' }}>{data.descricao}</Typography>
            {showValues ? (
                <Typography sx={{ fontSize: '13px' }} data-clarity-mask="true">
                    {formatCurrency(data.valor)}
                </Typography>
            ) : (
                <Skeleton variant="rounded" animation={false} width="3.7rem" height="1rem" />
            )}
        </Grid>
    );
};
